import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]


export default /*@__PURE__*/_defineComponent({
  __name: 'RestaurationIcon',
  props: {
    width: {},
    height: {}
  },
  setup(__props: any) {

// Props
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: props.width || 21,
    height: props.height || 21,
    class: "icon"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("use", { "xlink:href": "#___icon___restauration" }, null, -1)
  ]), 8, _hoisted_1))
}
}

})